module.exports = __webpack_public_path__ + "img/example.8ed8465e.png";